var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-decor",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"blob blob--a"}),_c('div',{staticClass:"blob blob--b"}),_c('div',{staticClass:"blob blob--c"})])
}]

export { render, staticRenderFns }